// let SITE_URL =  "https://mags2.trend-soft.de/" // "https://shop.mags-vertrieb.de/"
let SITE_URL =  "https://shop.mags-vertrieb.de/"
let API_SERVER = "/"
// let CMS_SERVER = "https://shop.mags-vertrieb.de/wp/" // "/wp/"
let CMS_SERVER =  "/wp/"

if(document.location.hostname === "localhost" || document.location.hostname === "blandland.herokuapp.com") {
  API_SERVER = SITE_URL
  CMS_SERVER = SITE_URL + "wp/"
}

const config     = {
  BASE:  API_SERVER,
  API:   API_SERVER + "shop/rest/",
  CMS:   CMS_SERVER + "wp-json/wp/v2/",
  MEDIA: API_SERVER + "shop/rest/data/images/",

  MIN_ORDER_VALUE: 150,
  pageSize: 24,

  b2cLink: false,
  //forms
  customer_registration: true,
  customer_enabling: false,
}

export default config



// WEBPACK FOOTER //
// ./src/config.js